import { ModuleWithProviders } from '@angular/core';
import { ElementService } from './services/element.service';
import { EnvironmentService } from './services/environment.service';
import { TranslationService } from './services/translation.service';

export class PortalLibModule {
  static forRoot(): ModuleWithProviders<PortalLibModule> {
    return {
      ngModule: PortalLibModule,
      providers: [ElementService, EnvironmentService, TranslationService],
    };
  }
}
